import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { useAnnotationsToggle } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/hooks/useAnnotationsToggle";
export const ToggleAnnotationsButton = /*#__PURE__*/ memo((param)=>{
    let { className } = param;
    const { showAnnotations, isAnnotationsEnabled, hideAnnotations } = useAnnotationsToggle();
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "filled",
        className: tailwindMerge("bg-pigeon-700 text-pigeon-25 hover:bg-pigeon-100/25 hover:text-pigeon-25 active:bg-pigeon-800 active:text-pigeon-600 disabled:bg-pigeon-800 disabled:text-pigeon-600", className),
        color: "grey",
        "data-testid": "TOGGLE_SHOW_ANNOTATIONS_BUTTON",
        onClick: isAnnotationsEnabled ? hideAnnotations : showAnnotations,
        size: "large",
        children: isAnnotationsEnabled ? "Hide Annotations" : "Show Annotations"
    });
});
ToggleAnnotationsButton.displayName = "ToggleAnnotationsButton";
